import { UTCDate } from '@date-fns/utc';
import { useUpdateTask } from '@task-manager/entities/tasks';
import { Check } from 'lucide-react';
import { useMutationToasts } from '@/shared/lib';
import { Tooltip } from '@/shared/ui';
import css from './task-complete-button.module.scss';

type TaskCompleteButtonProps = {
  taskId: string;
  completed: boolean;
};

/**
 * Green check button — sets `completedOn` to NOW. Click again on a
 * completed task unsets it (matches legacy "uncomplete" affordance).
 */
export const TaskCompleteButton = ({
  taskId,
  completed,
}: TaskCompleteButtonProps) => {
  const mutation = useUpdateTask();
  useMutationToasts(mutation, { success: 'Status updated' });
  const label = completed ? 'Mark not completed' : 'Mark completed';
  return (
    <Tooltip content={label}>
      <button
        aria-label={label}
        aria-pressed={completed}
        className={completed ? css.rootIsCompleted : css.root}
        disabled={mutation.isPending}
        onClick={() =>
          mutation.mutate({
            id: taskId,
            completedOn: completed ? null : new UTCDate().toISOString(),
          })
        }
        type="button"
      >
        <Check size={14} />
      </button>
    </Tooltip>
  );
};
